import { reactive } from 'vue';

type StateType = {
  aliasChecked: boolean;
  aliasOld: string;
  aliasNew: string;
};

const state = reactive<StateType>({
  aliasChecked: false,
  aliasOld: '',
  aliasNew: '',
});

export default state;
